import React from 'react';

type LegalizacionApostillasTableProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-table';

export const LegalizacionApostillasTable: React.FC<LegalizacionApostillasTableProps> = ({ className = '' }) => (
	<>
		<div className={`${classNameComponent} ${className} o-grid`}>
			<div className={`${classNameComponent} ${className || ''}`}>
				{/* Header: 2/10 */}
				<div className={`${classNameComponent}__header`}>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--firstCol`}>
						Del 16 de septiembre al 30 de junio
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio normal
					</div>
				</div>

				{/* Body row 1: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>De lunes a jueves</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 17 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación al tercer día hábil de 8.30 a 17 horas. (Puede variar en función del
						número de documentos entregados).
					</div>
				</div>

				{/* Body row 2: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>Viernes</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 14 horas.</div>
					<div className={`${classNameComponent}__cell`}>Viernes tarde cerrado.</div>
				</div>

				{/* ////////////////////////////////////////////////////////////////////  */}

				{/* Header: 2/10 */}
				<div className={`${classNameComponent}__header ${classNameComponent}__header--noRadius`}>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--noRadius`}>
						Del 1 de julio al 15 de septiembre
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio normal
					</div>
				</div>

				{/* Body row 1: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>De lunes a viernes</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 14 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación al tercer día hábil de 8.30 a 15 horas. (Puede variar en función del
						número de documentos entregados).{' '}
					</div>
				</div>

				{/* ////////////////////////////////////////////////////////////////////  */}

				{/* Header: 2/10 */}
				<div
					className={`${classNameComponent}__header ${classNameComponent}__header--noRadius ${classNameComponent}__header--doble`}
				>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--noRadius`}>
						Del 16 de septiembre al 30 de junio
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
				</div>

				{/* Body row 1: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>De lunes a jueves</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 13 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación el mismo día de 15 a 17 horas.
					</div>
				</div>

				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>Viernes</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 13 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación el mismo día de 14.30 a 15 horas. Viernes tarde cerrado.
					</div>
				</div>

				{/* ////////////////////////////////////////////////////////////////////  */}

				{/* Header: 2/10 */}
				<div
					className={`${classNameComponent}__header ${classNameComponent}__header--noRadius ${classNameComponent}__header--doble`}
				>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--noRadius`}>
						Del 1 de julio al 15 de septiembre
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
				</div>

				{/* Body row 1: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>De lunes a viernes</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 12 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación el mismo día de 14.30 a 15 horas.
					</div>
				</div>

				{/* ////////////////////////////////////////////////////////////////////  */}

				{/* Header: 2/10 */}
				<div
					className={`${classNameComponent}__header ${classNameComponent}__header--noRadius ${classNameComponent}__header--doble`}
				>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--noRadius`}>
						Del 16 de septiembre al 30 de junio
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
				</div>

				{/* Body row 1: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>De lunes a jueves</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 13 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación al día siguiente de 8.30 a 17 horas
					</div>
				</div>

				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>Viernes</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 13 horas.</div>
					<div className={`${classNameComponent}__cell`}>Viernes tarde cerrado.</div>
				</div>

				{/* ////////////////////////////////////////////////////////////////////  */}

				{/* Header: 2/10 */}
				<div
					className={`${classNameComponent}__header ${classNameComponent}__header--noRadius ${classNameComponent}__header--doble`}
				>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--noRadius`}>
						Del 1 de julio al 15 de septiembre
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
					<div className={`${classNameComponent}__cell ${classNameComponent}__header--service`}>
						Servicio muy urgente
					</div>
				</div>

				{/* Body row 1: 2 / 5 / 5 */}
				<div className={`${classNameComponent}__body`}>
					<div className={`${classNameComponent}__cell`}>De lunes a viernes</div>
					<div className={`${classNameComponent}__cell`}>Recepción de documentación de 8.30 a 12 horas.</div>
					<div className={`${classNameComponent}__cell`}>
						Retirada de documentación al siguiente día hábil de 8.30 a 15 horas
					</div>
				</div>
			</div>
		</div>

		<div className="u-mt-24">
			<p>
				El precio del Servicio Muy Urgente es de <strong>65 euros</strong>, incluido IVA
			</p>
			<p>
				El precio del Servicio Urgente es de <strong>50 euros</strong>, incluido IVA
			</p>
			<p>
				El precio del Servicio Normal es de <strong>25 euros</strong>, incluido IVA
			</p>
			<p>Se puede pagar en metálico o con tarjeta.</p>
		</div>
	</>
);
